import { render, staticRenderFns } from "./SponsoringUnitPage.vue?vue&type=template&id=6ceb9d5f&"
import script from "./SponsoringUnitPage.vue?vue&type=script&lang=ts&"
export * from "./SponsoringUnitPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ceb9d5f')) {
      api.createRecord('6ceb9d5f', component.options)
    } else {
      api.reload('6ceb9d5f', component.options)
    }
    module.hot.accept("./SponsoringUnitPage.vue?vue&type=template&id=6ceb9d5f&", function () {
      api.rerender('6ceb9d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/SponsoringUnitPage.vue"
export default component.exports